<template lang="pug">
b-form-select(
  :value="value"
  :size="size"
  :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
  @input="handleInput"
  @change="handleChange"
)
  //- option(value="" disabled selected) {{ $t("ui.all") }}
  option(v-if="isEnableOpt(option.value)" v-for="option in options" :value="option.value") {{ $t(option.text) }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "MEMBER"
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    hideOpt: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    options: [
      {
        value: "MEMBER",
        text: "ui.member"
      },
      {
        value: "AFFILIATE",
        text: "ui.affiliate"
      },
      {
        value: "OPERATOR",
        text: "ui.operator"
      },
    ]
  }),
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    },
    handleChange(e) {
      this.$emit("change", e);
    },
    isEnableOpt(value) {
      if (this.hideOpt && this.hideOpt.length > 0) {
        if (this.hideOpt.includes(value))
          return false;
      }

      return true;
    }
  }
};
</script>
